import { Component, OnInit } from '@angular/core';
import { MailboxService } from 'src/services/mailbox/mailbox.service';
import { AppComponent } from '../app.component';
import { SweetServices } from 'src/services/sweet.services';
import { NgForm } from '@angular/forms';
import { AnonymousMailbox } from '../model/mailbox/anonymousmailbox.model';
import { CasoMailbox } from '../model/mailbox/caso.model';
import { CasoPreocupante } from '../model/mailbox/casopreocupante.model';
import { BuscarCasos } from 'src/app/model/pld/buscarcaso.model';
import { AlertasService } from 'src/services/pld/alertas.service';
import { DetalleCaso, ModelCasoInusual } from 'src/app/model/pld/detallecaso.model';

@Component({
  selector: 'app-mailbox',
  templateUrl: './mailbox.component.html',
  styles: []
})
export class MailboxComponent implements OnInit {
  alertaEmpleados: number = 8;
  alertaClientes: number = 9;

  //#region DatosBuzon
  anonymousMailbox: AnonymousMailbox;
  casoPreocupante: CasoPreocupante;
  caso: CasoMailbox;
  casos: BuscarCasos;
  total: number;
  detalle: DetalleCaso;
  casosResultados: [];
  totalRegistros: number;
  personasResultados: [];
  leyenda: string;
  ModelCasoInusual: ModelCasoInusual;
  campoPersona: string;
  private timeoutId: any;
  public buscando: boolean = false;
  tipoPersona: number;
  tipoAlerta: string;
  //#endregion DatosBuzon

  viewDropDown: boolean;
  viewDropDownError: boolean;

  constructor(
    private main: AppComponent,
    private mailboxService: MailboxService,
    public alertaService: AlertasService,
    private alerta: SweetServices
  ) {
    this.caso = new CasoMailbox();
    this.casoPreocupante = new CasoPreocupante();
    this.casos = new BuscarCasos();
    this.casosResultados = [];
    this.total = 0;
    this.totalRegistros = 0;
    this.ModelCasoInusual = new ModelCasoInusual();
    this.tipoPersona = 1;
    this.tipoAlerta = 'INTERNA PREOCUPANTE';
    this.campoPersona = 'Empleado';
  }

  ngOnInit() {
    this.anonymousMailbox = new AnonymousMailbox();
  }

  buscarPersona() {
    this.ModelCasoInusual.tipoPersona = this.tipoPersona;
    this.leyenda = "Buscando " + this.campoPersona + "...";

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.personasResultados = [];
    if (this.ModelCasoInusual.nombre.length > 3) {
      this.timeoutId = setTimeout(() => {
        this.buscando = true;
        this.mailboxService.obtenerPersonasBuzon(this.ModelCasoInusual).subscribe(
          response => {
            this.main.loading = false;
            if (!response) {
              this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
            } else if (response.isCorrect === 'false') {
              this.alerta.AlertaError(response.message);
            } else if (response.data.total === 0) {
              this.personasResultados = [];
              this.viewDropDownError = true;
              this.viewDropDown = false;
            } else {
              this.personasResultados = response.data.info.result;
              this.personasResultados.forEach(element => {
                this.caso.PersonaId = element['personaId'];
              });
              this.leyenda = "Se encontró " + this.campoPersona;
              this.viewDropDownError = false;
              this.viewDropDown = true;
            }
            this.buscando = false;
          },
          err => {
            this.main.loading = false;
            this.buscando = false;
            this.alerta.AlertaCatch(err);
          }
        );
      }, 1000);
    } else {
      this.buscando = false;
    }
  }

  validaTipoPersona(value: number) {
    this.personasResultados = [];
    this.caso.PersonaId = -1;
    this.caso.AlertaId = value == 1 ? this.alertaEmpleados : this.alertaClientes;
    this.tipoAlerta = value == 1 ? 'INTERNA PREOCUPANTE' : 'BUZÓN ANÓNIMO';
    this.campoPersona = value == 1 ? 'Empleado' : 'Cliente';
    this.casoPreocupante.Descripcion = '';
    this.leyenda = '';
    this.viewDropDownError = false;
    this.ModelCasoInusual = new ModelCasoInusual();
    this.ModelCasoInusual.tipoPersona = value;
  }

  guardaFormulario(formMailbox: NgForm) {
    let error: boolean;
    error = false;
    this.anonymousMailbox.Caso = this.caso;
    this.anonymousMailbox.CasoPreocupante = this.casoPreocupante;
    this.anonymousMailbox.Caso.AlertaId = this.tipoPersona === 1 ?
      this.alertaEmpleados : this.alertaClientes;
    this.anonymousMailbox.Caso.PersonaId = +this.anonymousMailbox.Caso.PersonaId;
    this.anonymousMailbox.EsCasoEmpleado = this.tipoPersona === 1 ?
      true : false;

    if (this.anonymousMailbox.Caso.PersonaId != -1 &&
      this.anonymousMailbox.Caso.AlertaId != -1) {
      this.guardaMailbox(this.anonymousMailbox);
    } else {
      if (!this.anonymousMailbox.EsCasoEmpleado) {
        this.alerta.AlertaError('Selecciona un Cliente.');
      }
      else {
        this.alerta.AlertaError('Selecciona un Empleado.');
      }
    }
  }

  guardaMailbox(anonymousMailbox: AnonymousMailbox) {
    this.mailboxService.guardarMailbox(anonymousMailbox).subscribe(response => {
      this.main.loading = false;
      if (response == null) {
        this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
      } else if (response.isCorrect === 'false') {
        this.alerta.AlertaError(response.message);
      } else {
        this.alerta.AlertaConfirm(response.message);
        this.caso = new CasoMailbox();
        this.casoPreocupante = new CasoPreocupante();
        this.anonymousMailbox = new AnonymousMailbox();
        this.ModelCasoInusual = new ModelCasoInusual();
        this.leyenda = '';
      }
    }, (err) => {
      this.main.loading = false;
      this.alerta.AlertaCatch(err);
    });
  }

  bucarCasos() {
    this.casosResultados = [];
    this.total = 0;
    this.totalRegistros = 0;
    this.casos.NoCasoBuzon = +this.casos.NoCaso;
    this.casos.NoCaso = 0;
    this.casosResultados = [];
    this.alertaService.buscarCasosBuzon(this.casos).subscribe(response => {
      this.main.loading = false;
      if (response == null) {
        this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
      } else if (response.isCorrect === 'false') {
        this.casos.Pagina > 1 ? this.casos.Pagina-- : this.casos.Pagina = 1;
        this.alerta.AlertaError(response.message);
      } else if (response.data.total === 0) {
        this.alerta.AlertaSinResultados(response.message);
        this.casos.Pagina > 1 ? this.casos.Pagina-- : this.casos.Pagina = 1;
      } else {
        this.total = response.data.total;
        this.casosResultados = response.data.info.result;
        this.totalRegistros = response.totalRegistros;
      }
    }, (err) => {
      this.main.loading = false;
      if (err.error.message == null) {
        this.alerta.AlertaCatch(err);
      } else {
        this.alerta.AlertaError(err.error.message);
      }
    });
  }

  detalleCaso(caso: any) {
    this.casos = new BuscarCasos();
    this.alerta.AlertaInfoBuzon(caso['dictamen']);
  }

  validarFormulario(formBuscarCasos: NgForm) {
    let error: boolean;
    error = false;
    if (error) { return; }
    if (formBuscarCasos.valid) {
      this.main.loading = true;
      this.casos.Pagina = 1;
      this.bucarCasos();
    }
  }
}
